import { render, staticRenderFns } from "./taskSelectFilterDepartments.vue?vue&type=template&id=08c8a3bf&scoped=true&"
import script from "./taskSelectFilterDepartments.vue?vue&type=script&lang=js&"
export * from "./taskSelectFilterDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c8a3bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
